<template>
  <div>
    <!--    <el-row :gutter="20" style="margin-bottom: 15px;">-->
    <!--&lt;!&ndash;      <el-col :span="4">&ndash;&gt;-->
    <!--&lt;!&ndash;        <div style="height: 35px;line-height: 30px;">{{ mainTypeName }}</div>&ndash;&gt;-->
    <!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
    <!--      <el-col :span="4" :offset="16" style="text-align: right;">-->
    <!--        <el-button @click="handleAdd()" type="primary" size="small">添加</el-button>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
    <div style="margin-bottom: 10px">
      <el-button @click="handleAdd()" type="primary" size="small">添加</el-button>
    </div>
    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">
      <!-- '排序', '图标', '分类名称', '修改人', '修改时间', '操作' -->
      <el-table-column prop="id" label="ID" header-align="center" align="center" sortable></el-table-column>
      <el-table-column prop="sort" label="排序" header-align="center" align="center" sortable></el-table-column>
      <el-table-column prop="image_url" label="图标" header-align="center" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.image_url" :preview-src-list="[scope.row.image_url]"
                    style="width: 100px; height: 100px"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="con_type" label="展示类型" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.con_type == '1'" type="warning" disable-transitions>
           列表
          </el-tag>
          <el-tag v-if="scope.row.con_type == '2'" type="danger" disable-transitions>
            图片
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="title" label="分类名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="introduce" label="简介" header-align="center" align="center"></el-table-column>
      <el-table-column prop="modifier" label="修改人" header-align="center" align="center"></el-table-column>
      <el-table-column prop="modify_time" label="修改时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="opt" label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <el-link @click="handleEdit(scope.$index, scope.row)"
                   type="primary" :underline="false" style="padding-right: 10px;">编辑
          </el-link>
          <el-link @click="handleDel(scope.$index, scope.row)" type="danger" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹框 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible">
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px">
        <el-form-item label="分类名称" prop="title">
          <el-input v-model="editForm.title" placeholder="请输入分类名称" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="introduce">
          <el-input v-model="editForm.introduce" placeholder="请输入简介" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort" placeholder="请输入排序" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="展示类型" prop="con_type">
              <el-radio v-model="editForm.con_type" label="1">列表</el-radio>
              <el-radio v-model="editForm.con_type" label="2">图片</el-radio>
        </el-form-item>

        <el-form-item label="图片" prop="image_url" style="margin-bottom: 17px">
          <el-upload
              ref="uploads"
              class="avatar-uploader "
              :action="uploadImgUrl"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :on-error="handleUploadError"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="headers"
              :limit="1"
              :on-exceed="onExceed"
              :file-list="fileList"
              style="width: 500px"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImg123" append-to-body>
            <div class="demo-image__preview">
              <el-image width="100%" :src="editForm.image_url" alt=""></el-image>
            </div>
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditForm()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "subClassificationManage",
  data() {
    return {
      // 页面传参
      mainId: this.$route.query.id || null,//主分类id
      mainTypeName: this.$route.query.name || "",//主分类名称

      loading: false,
      tableData: [], //表格数据

      // 编辑弹框部分
      dialogVisible: false,//是否显示弹框
      editForm: {
        id: '',
        type_from: this.mainId,
        title: '',//分类名称
        introduce: '',//简介
        con_type:"1", //展示类型
        sort: '',//排序
        image_url: '',//图片地址
      },
      rules: {
        title: [{
          required: true,
          message: '请输入分类名称',
          trigger: 'blur'
        }],
        introduce: [{
          required: true,
          message: '请输入简介',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
        image_url: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }]
      },
      uploadImgUrl: "/api/system/uploadFile", // 上传图片的后台controller的地址
      fileList: [],
      headers: {  // 请求头部参数
        token: sessionStorage.getItem('token')
      },
      dialogVisibleImg123: false,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    //获取数据
    getData() { //初始化数据
      this.loading = true;
      this.$api.post("/api/school/cateSub", {id: this.mainId}, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.tableData = tableData;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      });
    },
    //添加子分类
    handleAdd() {
      this.editForm = {
        id: '',
        type_from: this.mainId,
        title: '',//分类名称
        introduce: '',//简介
        con_type:"1", //展示类型
        sort: '',//排序
        image_url: '',//图片地址
      }
      this.fileList = [];
      this.dialogVisible = true;
    },
    //编辑
    handleEdit(index, row) {
      //console.log(JSON.stringify(row))
      //查询详情信息并回显
      this.$api.post("/api/school/cateSubDetail", {id: row.id}, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.dialogVisible = true;
          this.editForm = tableData;
          this.editForm.con_type = String(tableData.con_type);
          this.fileList = [{
            name: '',
            url: tableData.image_url,
          }]
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 编辑弹框提交
    submitEditForm() {
      //console.log(this.editForm);
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.$api.post("/api/school/cateSubForm", this.editForm, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              this.getData();//刷新列表
              this.dialogVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //子分类删除
    handleDel(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let params = {id: row.id};
        this.delData(params);// 删除数据
      }).catch(() => {
        // 点击取消
      });
    },
    delData(params) {
      this.$api.post("/api/school/cateSubDelete", params, res => {
        if (res.status == 200) {
          this.$message.success('删除成功!');
          this.getData();//刷新列表
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //上传图片相关
    //上传图片
    handleAvatarSuccess(res) {
      if (res.status == 200) {
        this.editForm.image_url = res.data.url;
        this.$message({
          message: '图片上传成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
        this.fileList = []
      }
    },
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.editForm.image_url = '';
    },
    handleRemove(file) {
      this.editForm.image_url = '';
    },
    handlePictureCardPreview(file) {
      this.dialogVisibleImg123 = true;
    },
    onExceed() {
      this.$message({
        type: 'warning',
        message: '当前限制选择 1 个文件，本次选择了 1 个文件，共选择了 2 个文件',
        duration: 1000,
      });
    },
  }
}
</script>

<style scoped>

</style>